/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import * as wjCore from "@grapecity/wijmo"
import * as wjGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import * as wjcCore from "@grapecity/wijmo"

// other
import queryString from "query-string"
import { useEffect, useState } from "react"
import { Button, Card, Col, Collapse, Container, Row } from "react-bootstrap"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faChevronDown,
  faChevronUp,
  faSearch,
} from "@fortawesome/free-solid-svg-icons"

import { useHistory, useLocation } from "react-router-dom"
import AlertComponent from "../../../components/AlertComponent"

import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import TextInput from "../../../components/InputWrapper/TextInput"
import Spinner from "../../../components/Spinner"
import CONST from "../../../constant"

import {
  TZyomuinListGetReq,
  TZyomuinListItem,
} from "../../../service/driver/TZyomuin"

import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"

import { useDispatch, useSelector } from "react-redux"
import { RootState } from "../../../globalStore/rootreducer"

import { TWijmoCellTemplateContext } from "../../../type/wijmoComponents"
import { TWijmoComboBox } from "../../../type/wijmoComponents"

import ComboBox from "../../../components/ComboBox"
import { AppDispatch } from "../../.."
import { clearAlert, setAlerts } from "../../../globalStore/alertStore"
import util from "../../../ts/util"
import { メニューコード } from "../../../constant/menuCode"
import BusyoService from "../../../service/master/busyo/busyoService"
import { T部所マスタ } from "../../../components/ComboBox/BusyoComboBox"
import { Form } from "react-bootstrap"
import ZyomuinService from "../../../service/driver/zyomuinService"
import commonUtil from "../../../ts/util/commonUtil"
import VALIDATE_CONSTANT from "../../../constant/validateConstant"
import dateUtil from "../../../ts/util/dateUtil"

// //#region [type]

// DefaultCombo
export type TItem = { name: string; value: any }

export type T乗務員明細リスト = TZyomuinListItem & { 行ID: symbol }

// #endregion

// defaultComboBox用
const boolList: TItem[] = [
  {
    name: "在籍",
    value: "0",
  },
  {
    name: "退職",
    value: "1",
  },
]

// #endregion

/**
 * 乗務員マスタ一覧
 */
const ZyomuinMasterList = () => {
  const history = useHistory()
  const location = useLocation()
  const 営業日 = useSelector((state: RootState) => state.date.eigyobiStr)

  const 読取専用フラグ = useSelector(
    (rootState: RootState) =>
      rootState.menu.menuPage.find(
        (m) => m.メニューコード === メニューコード.乗務員管理.乗務員マスタ一覧
      )?.読み取り専用フラグ
  )

  //TODO:ページ名称確定必須
  let gridId = "ZyomuinMasterList_GridId"

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (
    data: Array<T乗務員明細リスト>,
    pageSize: number
  ) =>
    new wjCore.CollectionView(data, {
      pageSize,

      calculatedFields: {
        // 年齢を計算
        年齢: (i: T乗務員明細リスト) => {
          if (i.生年月日 == null || wjcCore.isNullOrWhiteSpace(i.生年月日))
            return undefined
          let targetDate = Date.parse(i.生年月日)
          let today = Date.parse(eigyobi)
          let retDay = (today - targetDate) / 86400000
          let age = Math.floor(retDay / 365)
          return age
        },
        在籍年数: (item: T乗務員明細リスト) => {
          return dateUtil.to在籍年月数Str(
            営業日,
            item.入社年月日,
            item.退職年月日
          )
        },
        sort_社員コード: (i: T乗務員明細リスト) =>
          commonUtil.createSortString(
            i.社員コード,
            VALIDATE_CONSTANT.LENGTH.社員コード
          ),
      },

      sortDescriptions: [new wjCore.SortDescription("sort_社員コード", true)],

      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
    })

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (
    searchCondition?: TZyomuinListGetReq,
    signal?: AbortSignal
  ) => {
    setSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) //Alertクリア

    let currentSearchCondition: TZyomuinListGetReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition)
    )

    try {
      const res = await new ZyomuinService().getList(
        currentSearchCondition,
        signal
      )

      // 検索結果をstateにセット
      setGridData({
        data: createCollectionView(
          res.data.map((v) => {
            return {
              ...v,
              行ID: Symbol(),
            }
          }),
          pageSize
        ),
      })

      //setAccordionController(false)
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setSearching(false) // 検索中状態に遷移
    }
  }

  /**
   * URL Queryを解析
   */
  const queryParse = () => {
    const query: TZyomuinListGetReq = queryString.parse(location.search)
    set部所コード(query.部所コード ?? "")
    set社員コード(query.社員コード ?? "")
    set社員氏名(query.社員氏名 ?? "")
    set社員氏名カナ(query.社員氏名カナ ?? "")
    set退職フラグ(query.退職フラグ != null ? query.退職フラグ.toString() : "")

    return query
  }

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TZyomuinListGetReq => {
    return {
      部所コード: 部所コード ?? "",
      社員コード: 社員コード ?? "",
      社員氏名: 社員氏名 ?? "",
      社員氏名カナ: 社員氏名カナ ?? "",
      退職フラグ:
        退職フラグ != null && !wjcCore.isNullOrWhiteSpace(退職フラグ)
          ? parseInt(退職フラグ)
          : undefined,
    }
  }

  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (
    searchCondition: TZyomuinListGetReq
  ) => {
    return {
      部所: 部所ItemSource?.find(
        (i) => i.部所コード === searchCondition.部所コード
      )?.部所名,
      社員CD: searchCondition.社員コード,
      社員氏名: searchCondition.社員氏名,
      退職: boolList?.find(
        (i) => i.value === searchCondition.退職フラグ?.toString()
      )?.name,
    }
  }

  /**
   * 検索条件クリア処理
   */
  const searchConditionClear = () => {
    // フィルターのクリア
    if (!searching) {
      flexGrid!.collectionView.filter = null
      flexGrid!.collectionView.sortDescriptions.clear()
    }
    // データをすべて削除する
    const emptyCollectionView = createCollectionView([], pageSize)
    flexGrid!.itemsSource = emptyCollectionView
    setGridData({ data: emptyCollectionView })
    // 検索条件文字列をクリア
    setDisplaySearchCondition(undefined)
    // 検索項目をクリア
    clearSearchState()
    // querystringをクリア
    pageHelper.clearQuery(history, location)
    // アコーディオンを開く
    setAccordionController(true)
  }

  const clearSearchState = () => {
    set部所コード("")
    set社員コード("")
    set社員氏名("")
    set退職フラグ("0")
  }

  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(10)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  // 検索制御用
  const [searching, setSearching] = useState(false) // 検索中

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any
  }>()

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)

  // // grid内エラー項目格納Array
  // const [errorCellPositionList] = useState<
  //   Array<{ 行ID: symbol; colBinding: string }>
  // >([])
  // const [Form外エラーメッセージList] = useState<string[]>([])
  // // errorフラグ
  // const [hasSearched, setHasSearched] = useState(false)

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)

  // ComboBox制御
  const [comboDataInitialized, setComboDataInitialized] =
    useState<boolean>(false)

  //#endregion

  //#region [state]

  // ComboBoxState

  const [退職フラグComboBox, set退職フラグComboBox] = useState<TWijmoComboBox<
    number,
    TItem
  > | null>(null)
  const [退職フラグIsLoadEnded, set退職フラグIsLoadEnded] =
    useState<boolean>(false)
  const [退職フラグItemSource, set退職フラグItemSource] = useState<TItem[]>()

  const [部所ComboBox, set部所ComboBox] = useState<TWijmoComboBox<
    string,
    T部所マスタ
  > | null>(null)
  const [部所IsLoadEnded, set部所IsLoadEnded] = useState<boolean>(false)
  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>()

  // 設定
  const eigyobi = useSelector((state: RootState) => state.date.eigyobiStr)

  const [部所コード, set部所コード] = useState<string | null>(null)
  const [社員コード, set社員コード] = useState<string>("")
  const [社員氏名, set社員氏名] = useState<string>("")
  const [社員氏名カナ, set社員氏名カナ] = useState<string>("")
  const [退職フラグ, set退職フラグ] = useState<string | null>("0")

  //#endregion

  //#region [effect]

  useEffect(() => {
    Promise.all([new BusyoService().getList({})]).then(([部所ListRes]) => {
      set退職フラグItemSource(boolList)
      set部所ItemSource(部所ListRes.data)
      set退職フラグ("0")
    })
  }, [])

  useEffect(() => {
    if (!部所IsLoadEnded || !退職フラグIsLoadEnded) return

    setComboDataInitialized(true)
  }, [部所IsLoadEnded, 退職フラグIsLoadEnded])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized && comboDataInitialized) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse()

        // リストア中フラグON
        setIsRestoreSearching(true)

        // 再検索
        search(querySearchCondition)
      } else {
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
      }
    }
  }, [gridInitialized, comboDataInitialized])

  useEffect(() => {
    document.title = `乗務員マスタ一覧`
  }, [])
  //#endregion

  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span className="page-title">乗務員マスタ一覧</span>
        </Col>
      </Row>
      {/* アラート表示 */}
      <Row>
        <Col>
          <AlertComponent />
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索条件カード */}
          <Card className="w-90rem">
            {/* CardHeaderをアコーディオン化 */}
            <Card.Header
              onClick={() => setAccordionController(!accordionController)}
              aria-controls="collapse-search-card-body"
              aria-expanded={accordionController}>
              <FontAwesomeIcon
                icon={accordionController ? faChevronDown : faChevronUp}
                size={"1x"}
              />
              検索条件
            </Card.Header>
            <Collapse in={accordionController}>
              <Card.Body id="collapse-search-card-body">
                <Form>
                  <Container fluid className="contents-search-main">
                    <Row>
                      <Col>
                        <div className="search-condition-table">
                          <div className="search-condition-row">
                            <ComboBox.Busyo
                              autoFocus={true}
                              placeholder="部所"
                              isAllSelect={true}
                              itemsSource={部所ItemSource}
                              selectedValue={部所コード}
                              setSelectedValue={set部所コード}
                              isLoadEnded={部所IsLoadEnded}
                              setIsLoadEnded={set部所IsLoadEnded}
                              ComboBox={部所ComboBox}
                              setComboBox={set部所ComboBox}></ComboBox.Busyo>
                            <div className="input-group">
                              <TextInput
                                style={{ width: "6rem" }}
                                id="社員コード"
                                name="社員コード"
                                value={社員コード}
                                setValue={set社員コード}
                                maxLength={4}
                                placeholder="社員CD"
                              />
                              <TextInput
                                style={{ width: "15rem" }}
                                id="社員氏名"
                                name="社員氏名"
                                value={社員氏名}
                                setValue={set社員氏名}
                                maxLength={100}
                                placeholder="社員氏名"
                              />
                              <TextInput
                                style={{ width: "15rem" }}
                                id="社員氏名カナ"
                                name="社員氏名カナ"
                                value={社員氏名カナ}
                                setValue={set社員氏名カナ}
                                maxLength={100}
                                placeholder="氏名カナ"
                              />
                            </div>
                            <ComboBox.Default
                              className="max-w-10rem"
                              placeholder="退職"
                              isAllSelect={true}
                              itemsSource={退職フラグItemSource}
                              selectedValue={退職フラグ}
                              setSelectedValue={set退職フラグ}
                              isLoadEnded={退職フラグIsLoadEnded}
                              setIsLoadEnded={set退職フラグIsLoadEnded}
                              ComboBox={退職フラグComboBox}
                              setComboBox={
                                set退職フラグComboBox
                              }></ComboBox.Default>
                          </div>
                          <div className="search-condition-row">
                            <Button
                              type="submit"
                              disabled={searching}
                              onClick={(e) => {
                                e.stopPropagation()
                                e.preventDefault()
                                search()
                              }}>
                              <FontAwesomeIcon icon={faSearch} />
                              検索
                            </Button>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Card.Body>
            </Collapse>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索結果カード */}
          <Card>
            <Spinner searching={searching}></Spinner>
            <Card.Body>
              <Row>
                <Col>
                  {/* 検索条件表示コンポーネント */}
                  <DisplaySearchConditionLabel
                    displaySearchCondition={displaySearchCondition}
                  />
                </Col>
              </Row>
              <FlexGridOuter
                flexGrid={flexGrid}
                setFlexGrid={setFlexGrid}
                gridConstantProperties={CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
                gridData={gridData}
                setGridData={setGridData}
                pageNumber={pageNumber}
                searchConditionClear={searchConditionClear}
                gridId={gridId}
                isRestoreSearching={isRestoreSearching}
                setIsRestoreSearching={setIsRestoreSearching}
                gridInitialized={gridInitialized}
                setGridInitialized={setGridInitialized}
                pageSize={pageSize}
                setPageSize={setPageSize}>
                <wjrGrid.FlexGridColumn
                  header=" "
                  align="center"
                  width={80}
                  selectable={false}
                  isReadOnly>
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<T乗務員明細リスト>
                    ) => {
                      const url = util.getMenuPath(
                        メニューコード.乗務員管理.乗務員マスタ登録
                      )[0]

                      return (
                        <Button
                          className="btn btn-small btn-primary move-edit-page"
                          onClick={() => {
                            // 画面全体のスクロール位置の保存
                            gridPageHelper.savePageConditionData(
                              location.pathname
                            )

                            history.push(
                              url.replaceAll(":id", `${context.item.乗務員ID}`)
                            )
                          }}>
                          {読取専用フラグ ? "参照" : "編集"}
                        </Button>
                      )
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="部所名"
                  width={200}
                  header="所属部所"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="社員コード"
                  width={100}
                  sortMemberPath="sort_社員コード"
                  header="社員CD"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="社員氏名"
                  width={150}
                  header="氏名"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="年齢"
                  width={80}
                  header="年齢"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="携帯電話番号"
                  width={130}
                  header="携帯電話番号"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="車番"
                  width={150}
                  header="担当車輌"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="入社年月日"
                  width={120}
                  dataType="Date"
                  header="入社日">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<T乗務員明細リスト>
                    ) => {
                      return (
                        <>
                          {context.item.入社年月日 &&
                            wjcCore.Globalize.format(
                              new Date(context.item.入社年月日),
                              "d"
                            )}
                        </>
                      )
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="在籍年数"
                  width={100}
                  align={"right"}
                  header="在籍年数"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="退職年月日"
                  width={120}
                  dataType="Date"
                  header="退職日">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<T乗務員明細リスト>
                    ) => {
                      return (
                        <>
                          {context.item.退職年月日 &&
                            wjcCore.Globalize.format(
                              new Date(context.item.退職年月日),
                              "d"
                            )}
                        </>
                      )
                    }}
                  />
                </wjrGrid.FlexGridColumn>
              </FlexGridOuter>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default ZyomuinMasterList
